import { EnvironmentProviders, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { combineEnvironmentProviders, isReallyOnline } from '@wheere-front/shared-util';
import { KeycloakAngularModule, KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { KeycloakAdminService } from './keycloak-admin.service';

function initializeKeycloak(keycloak: KeycloakService, admin: KeycloakAdminService, options: KeycloakOptions) {
  return async () => {
    const online = await isReallyOnline();
    if (!online) {
      return;
    }
    await keycloak.init(options);
    await admin.init(keycloak);
  };
}

const keycloakInitializer = (options: KeycloakOptions) => {
  return provideAppInitializer(() => {
    const initializerFn = ((keycloak: KeycloakService, admin: KeycloakAdminService) =>
      initializeKeycloak(keycloak, admin, options))(inject(KeycloakService), inject(KeycloakAdminService));
    return initializerFn();
  });
};

export function provideKeycloak(options: KeycloakOptions): EnvironmentProviders {
  return combineEnvironmentProviders([
    importProvidersFrom([KeycloakAngularModule]),
    keycloakInitializer(options) as unknown as EnvironmentProviders,
  ]);
}
